import CityPageSEO from "@/hooks/usePageSEO";
import StatesboroHeroSection from "./components/HeroSection";
import StatesboroStickyNav from "./components/StickyNav";
import StatesboroProcessingTimeSection from "./components/ProcessingTimeSection";
import StatesboroServicesSection from "./components/ServicesSection";
import StatesboroHowItWorksSection from "./components/HowItWorksSection";
import StatesboroLocalAreaSection from "./components/LocalAreaSection";
import StatesboroAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import StatesboroMistakesSection from "./components/MistakesSection";
import StatesboroComparisonSection from "./components/ComparisonSection";
import StatesboroFAQSection, { faqs } from "./components/FAQSection";
import StatesboroHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import StatesboroTestimonialsSection from "./components/TestimonialsSection";
import StatesboroFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function StatesboroPage() {
  return (
    <main className="min-h-screen bg-white">
      <CityPageSEO config={{
        cityName: "Statesboro",
        route: "/statesboro",
        description: "Emergency and expedited passport services in Statesboro, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Bulloch County and southeast Georgia travelers near Georgia Southern. Get your emergency passport fast!",
        geoPlacename: "Statesboro, Georgia",
        geoPosition: "32.4490;-81.7832",
        keywords: "expedited passport, emergency passport, Statesboro passport, same day passport Statesboro, fast passport Georgia, Bulloch County passport",
        faqs,
      }} />
      <StatesboroHeroSection />
      <StatesboroStickyNav />
      <StatesboroProcessingTimeSection />
      <StatesboroServicesSection />
      <StatesboroHowItWorksSection />
      <StatesboroLocalAreaSection />
      <StatesboroAcceptanceFacilitiesSection />
      <StatesboroMistakesSection />
      <StatesboroComparisonSection />
      <StatesboroFAQSection />
      <StatesboroHelpfulResourcesSection />
      <StatesboroTestimonialsSection />
      <SEOCrossLinks currentRoute="/statesboro" state="GA" />
      <StatesboroFinalCTA />
    </main>
  );
}